module.exports = __webpack_public_path__ + "pc/img/magazine_detail_bg.b4fe157f.jpg";